import {BASE_URL} from "../../config/network";

const idsfTransactionGroupAppendAPI = async ({groupId, payload = {}}) => {
    const normalizedGroupId = String(groupId || "").trim();
    if (!normalizedGroupId) {
        throw new Error("idsf_group_id is required");
    }

    const URL = `${BASE_URL}/public/id-sugarfree/transaction-group/${encodeURIComponent(normalizedGroupId)}`;
    const METHOD = "PATCH";
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    if (response.status === 204) {
        return {};
    }

    return await response.json();
};

export {idsfTransactionGroupAppendAPI};
